// extracted by mini-css-extract-plugin
module.exports = {"addButton":"ArticlesList_addButton__33d1o","disabled":"ArticlesList_disabled__13Myu"};